export default "https://cdn-static.gokick.com/assets/d6a1d1f7abc93216fd07fb40adb7adf28904b072/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";